import { getPath } from "../../utils";

const initialState = {
  subIssueTypeList: [],
  nextPage: -1,
  prevPage: -1,
  currentPage: 1,
  subIssueTypeDetails: {},
  activeFilters: {},
  remoteSearch: {
    subIssueTypesList: [],
    nextPage: -1,
    prevPage: -1,
    currentPage: 1,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_SUB_ISSUE_TYPE_LIST": {
      return setSubIssueTypeList(state, action);
    }
    case "SET_SUB_ISSUE_TYPE_DETAILS": {
      return setSubIssueTypeDetails(state, action);
    }
    case "SET_CURRENT_PAGE_SUB_ISSUE_TYPE": {
      return setCurrentPageSubIssueType(state, action);
    }
    case "SET_SUB_ISSUE_TYPE_ACTIVE_FILTERS":
      return setActiveFilters(state, action);
    case "SET_SUB_ISSUE_TYPE_LIST_REMOTE_SEARCH": {
      return setSubIssueTypeListRemoteSearch(state, action);
    }
    default: {
      return state;
    }
  }
}

const setSubIssueTypeList = (state, action) => {
  return {
    ...state,
    subIssueTypeList: getPath(action.payload, "data", []),
    nextPage: getPath(action.payload, "PageResponse.nextPage", -1),
    prevPage: getPath(action.payload, "PageResponse.previousPage", -1),
  };
};

const setSubIssueTypeDetails = (state, action) => {
  let obj = getPath(action.payload, "data", []);
  obj.issueId = obj.parentId;
  return {
    ...state,
    subIssueTypeDetails: obj,
  };
};
const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setCurrentPageSubIssueType = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setSubIssueTypeListRemoteSearch = (state, action) => {
  return {
    ...state,
    remoteSearch: {
      subIssueTypesList: getPath(action.payload, "subIssueTypes", []),
      nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
      prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    },
  };
};
